// file: src/components/TranslatedText.tsx

"use client";

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { warnMissingKey } from '@/lib/i18nMissingKey';

interface TranslatedTextProps {
  tKey: string;
  defaultValue?: string ; // can be string or React element for translation support
}

export default function TranslatedText({ tKey, defaultValue }: TranslatedTextProps) {
 
  const { t, i18n, ready } = useTranslation("translation");
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  // Développement : signale la clé absente du catalogue, sans toucher au rendu.
  // Sans effet en production ; un seul avertissement par langue et par clé.
  useEffect(() => {
    if (isClient && ready !== false && tKey && typeof i18n?.exists === "function" && !i18n.exists(tKey)) {
      warnMissingKey(i18n.language, tKey);
    }
  }, [isClient, ready, tKey, i18n]);

  if (!isClient) {
    return <>{defaultValue || ''}</>;
  }

  return <>{t(tKey, { defaultValue })}</>;
}